import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import InputAdornment from "@material-ui/core/InputAdornment";
import AccountCircle from "@material-ui/icons/AccountCircle";
import ModeCommentIcon from "@material-ui/icons/ModeComment";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";

import Fade from "react-reveal/Fade";

import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaGithub,
  FaLinkedinIn,
  FaRedditAlien,
  FaBloggerB,
} from "react-icons/fa";

import db from "../../firebase";

import "./Contact.css";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Contact() {
  var yr = new Date().getFullYear();

  var dob = new Date("02/06/1999");
  var month_diff = Date.now() - dob.getTime();
  var age_dt = new Date(month_diff);
  var year = age_dt.getUTCFullYear();
  var age = Math.abs(year - 1970);

  const [successMsg, setSuccessMsg] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [allFields, setAllFields] = useState(false);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [msg, setMsg] = useState("");

  function validateEmail(id) {
    const re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(id);
  }

  const handleInvalidEmailClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setInvalidEmail(false);
  };

  const handleSuccessMsgClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSuccessMsg(false);
  };

  const handleAllFieldsClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAllFields(false);
  };

  const sendResponse = (e) => {
    e.preventDefault();

    if (name !== "" && email !== "" && msg !== "") {
      if (validateEmail(email)) {
        db.collection("response").add({
          name: name,
          email: email,
          message: msg,
        });

        setSuccessMsg(true);
      } else if (!validateEmail(email)) {
        setInvalidEmail(true);
      }

      setName("");
      setEmail("");
      setMsg("");
    } else {
      setAllFields(true);
    }
  };

  return (
    <div className="contact" id="contact">
      <div className="contact_header">
        <h1>Contacts</h1>
        <h4>Get In Touch</h4>
      </div>
      <div className="contact_body">
        <div className="contact_bodyLeft">
          <div className="contact_input">
            <form>
              <br />
              <div className="input_container">
                <TextField
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountCircle className="contact_icons" />
                      </InputAdornment>
                    ),
                  }}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  variant="outlined"
                  fullWidth
                  label="Name"
                  color="secondary"
                  className="name"
                  type="text"
                />
                <br />
                <TextField
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AlternateEmailIcon className="contact_icons" />
                      </InputAdornment>
                    ),
                  }}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  variant="outlined"
                  fullWidth
                  label="Email"
                  color="secondary"
                  className="email"
                  type="email"
                />{" "}
                <br />
                <TextField
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <ModeCommentIcon className="contact_icons" />
                      </InputAdornment>
                    ),
                  }}
                  value={msg}
                  onChange={(e) => setMsg(e.target.value)}
                  variant="outlined"
                  fullWidth
                  label="Type Message"
                  multiline
                  rows={4}
                  color="secondary"
                  className="message"
                  type="text"
                />
                <br />
                <Button onClick={sendResponse}>Send Message</Button>
              </div>
              <Snackbar
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                autoHideDuration={3000}
                open={successMsg}
                onClose={handleSuccessMsgClose}
              >
                <Alert severity="success" onClose={handleSuccessMsgClose}>
                  Thanks For Dropping By 😁
                </Alert>
              </Snackbar>
              <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                autoHideDuration={3000}
                open={allFields}
                onClose={handleAllFieldsClose}
              >
                <Alert severity="info" onClose={handleAllFieldsClose}>
                  Please enter all the fields 🥵
                </Alert>
              </Snackbar>
              <Snackbar
                open={invalidEmail}
                autoHideDuration={3000}
                onClose={handleInvalidEmailClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
              >
                <Alert severity="error" onClose={handleInvalidEmailClose}>
                  Please enter a valid email 😅
                </Alert>
              </Snackbar>
            </form>
          </div>
          <div className="contact_details">
            <h2>Mohammed Sabeel</h2> <br />
            <h4>
              <span className="bold-effect">AGE:</span> {age}
            </h4>
            <h4>
              <span className="bold-effect">COUNTRY:</span> INDIA
            </h4>
            <a
              href="https://www.google.com/maps/place/Vaniyambadi,+Tamil+Nadu/@12.6770498,78.6014406,14z/data=!3m1!4b1!4m6!3m5!1s0x3bada9a399f60b0d:0x8ace6dc0bad6c5cc!8m2!3d12.6824796!4d78.6167374!16zL20vMGMybnI3?entry=ttu"
              target="blank"
              rel="noopener noreferrer"
            >
              <h4>
                <span className="bold-effect">ADDRESS</span>: K K STREET,
                VANIYAMBADI, TAMILNADU - 635751
              </h4>
            </a>
            <a href="tel:919087028535">
              <h4>
                <span className="bold-effect">PHONE:</span> +91 9087028535
              </h4>
            </a>
            <a href="mailto:sabeekmohammed@gmail.com">
              <h4>
                <span className="bold-effect">EMAIL:</span>{" "}
                sabeekmohammed@gmail.com
              </h4>
            </a>
          </div>
        </div>
        <div className="contact_bodyRight">
          <Fade bottom>
            <a
              href="https://www.instagram.com/sword_sabeel/"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram className="footer_icon" />
            </a>
            <a
              href="https://twitter.com/mohamme_sabeel"
              target="_blank"
              rel="noreferrer"
            >
              <FaTwitter className="footer_icon" />
            </a>
            <a
              href="https://in.linkedin.com/in/k-md-sabeel"
              target="_blank"
              rel="noreferrer"
            >
              <FaLinkedinIn className="footer_icon" />
            </a>
            <a
              href="https://www.facebook.com/SabeelKmd/"
              target="_blank"
              rel="noreferrer"
            >
              <FaFacebookF className="footer_icon" />
            </a>
            <a
              href="https://github.com/md-sabeel"
              target="_blank"
              rel="noreferrer"
            >
              <FaGithub className="footer_icon" />
            </a>
            <a
              href="https://www.reddit.com/"
              target="_blank"
              rel="noreferrer"
              className="d-none"
            >
              <FaRedditAlien className="footer_icon" />
            </a>
            <a
              href="http://www.mddevelopers.tk/"
              target="_blank"
              rel="noreferrer"
            >
              <FaBloggerB className="footer_icon" />
            </a>
          </Fade>
        </div>
      </div>
      <div className="contact_footer">
        <h4>Copyright © {yr} || MD-Developers</h4>
      </div>
    </div>
  );
}

export default Contact;
